import styled from "@emotion/styled";
import { Heading } from "react-aria-components";

export const PopupDialogHeading = styled(Heading)`
  font-family: "STK Bureau", Sans-Serif, sans-serif;

  /* Headlines (desktop)/Sub2 */
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 140%; /* 28px */
  letter-spacing: -0.4px;

  height: 24px;
  margin-bottom: 8px;
`;
